module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921041151_T.5dce4574.jpg";